import { IVariation } from '~/lib/data-contract';

import { extractSize } from '../extractSize/extractSize';

/**
 * Sort variants by size, starting with the smallest.
 */
export const sortSizeVariants = (variants: IVariation[]) => variants.sort((a, b) => extractSize(a.sizeAttribute) - extractSize(b.sizeAttribute));
